import { FETCH_PERMISSIONS , FETCH_PERMISSIONS_ATTEMPT} from '../../actions/types'
const INITIAL_STATE = {
    data: [],
    loading: false
}
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_PERMISSIONS_ATTEMPT:
            return { ...state, loading: true }
        case FETCH_PERMISSIONS:
            return { ...state, data: action.data, loading: false }
       default:
            return state;
    }
}